package com.milta.core.localization

/**
 * Strings specific to the package-label scan flow (MIL-25, `PackageLabelScanScreen` /
 * `PackageLabelReviewScreen`). Deliberately separate from [OcrScanStrings] (paper delivery list,
 * MIL-24/DOM-02): different copy ("étiquette"/singular delivery vs "document"/plural deliveries).
 * Screens B/E/F/G and C/D/D2 reuse [OcrScanStrings] members directly wherever the wording is
 * identical (rate limit banner, attempt pill, phone-not-detected note, common action labels — see
 * the mockup's own "Mapping composants réels" notes for which ones).
 */
data class PackageLabelScanStrings(
    // ── Écran B — lecture de l'étiquette ──
    val scanTitle: String,
    val analysingTitle: String,
    val analysingSubtitle: String,
    // ── Écran C — confirmer la livraison ──
    val reviewTitle: String,
    val deliveryDetectedLabel: String,
    val allReadableLabel: String,
    val fieldToCompleteSingularSuffix: String,
    val fieldToCompletePluralSuffix: String,
    // ── Écrans D/D2 — champ non reconnu ──
    val recipientNotDetectedValue: String,
    val addressNotDetectedValue: String,
    val phoneNotDetectedValue: String,
    val fieldRequiredWarning: String,
    val recipientCorrectionPlaceholder: String,
    val addressCorrectionPlaceholder: String,
    // ── Écran E — étiquette illisible, nouvelle tentative possible ──
    val unreadableTitle: String,
    val unreadableMessage: String,
    // ── Écran F — limite de tentatives client atteinte ──
    val maxAttemptsMessage: String,
)
